module.exports = __webpack_public_path__ + "img/finizens.345e3428.png";